import { addDays, getStartOfWeek } from '@/utils/dateUtils';
import { formatDateRange } from '@/utils/dateUtils/dateFormatUtils';
import type { DateString } from '@/types/state/filter';

/**
 * Label for a weekly CPT chart bucket, clipped to `[from, to]`. `bucketDate` may already be
 * clamped to `from` by the API, so the week end is derived from `getStartOfWeek(bucketDate)`,
 * not `bucketDate` itself.
 */
export const formatClippedWeekBucketLabel = (
  bucketDate: DateString,
  from: DateString,
  to: DateString
): string => {
  const displayStart = bucketDate < from ? from : bucketDate;
  const weekEnd = addDays(getStartOfWeek(bucketDate), 6);
  const displayEnd = weekEnd > to ? to : weekEnd;
  return formatDateRange(displayStart, displayEnd);
};
